import { render } from 'solid-js/web';
import Header from './components/Header';
import StatsDrawer from './components/StatsDrawer';
import BetPanelSolid from './components/BetPanel';
import RoundHistoryTop from './components/RoundHistoryTop';
import MultiplierView from './components/MultiplierView';
import OnlineCounter from './components/OnlineCounter';
import ModalManager from './components/modals/ModalManager';
import StreamerMode from './components/streamer/StreamerMode';

(window as any).__MemePump_SolidPhase1 = true;
(window as any).__MemePump_SolidPhase2 = true;
(window as any).__MemePump_SolidPhase3 = true;
(window as any).__MemePump_SolidPhase4 = true;
(window as any).__MemePump_SolidPhase5 = true;

(function mount() {
  const host = document.querySelector('.header-controls');
  if (host) {
    host.textContent = '';
    render(() => <Header />, host);
  }

  const statsDrawerHost = document.createElement('div');
  statsDrawerHost.id = 'stats-drawer-root';
  document.body.appendChild(statsDrawerHost);
  render(() => <StatsDrawer />, statsDrawerHost);

  const betPanelHost = document.getElementById('bet-panel');
  if (betPanelHost) {
    betPanelHost.textContent = '';
    render(() => <BetPanelSolid />, betPanelHost);
  }

  const rhStrip = document.getElementById('round-history-top-strip');
  if (rhStrip) {
    rhStrip.textContent = '';
    render(() => <RoundHistoryTop />, rhStrip);
  }

  const mvHost = document.createElement('div');
  document.body.appendChild(mvHost);
  render(() => <MultiplierView />, mvHost);

  const mmHost = document.createElement('div');
  document.body.appendChild(mmHost);
  render(() => <ModalManager />, mmHost);

  const streamerHost = document.createElement('div');
  streamerHost.id = 'streamer-mode-root';
  const visual = document.querySelector('.main-visual');
  (visual || document.body).appendChild(streamerHost);
  render(() => <StreamerMode />, streamerHost);

  const onlineHost = document.createElement('div');
  onlineHost.id = 'online-counter-root';
  (visual || document.body).appendChild(onlineHost);
  render(() => <OnlineCounter />, onlineHost);
})();
